<nz-select class="report-select" nzPlaceHolder="Please select"
    [(ngModel)]="value" (ngModelChange)="onChange($event)" name="accountant" nzAllowClear [nzDropdownRender]="loadingTpl">
    <nz-option nzCustomContent *ngFor="let item of accountant" [nzLabel]="item.code" [nzValue]="item.id">
      {{ item.code }} : {{ item.name }}
    </nz-option>
</nz-select>
<ng-template #loadingTpl>
  <nz-spin *ngIf="searching"></nz-spin>
<nz-divider class="m-none"></nz-divider>
</ng-template>